import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'
@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  constructor (private readonly httpClient: HttpClient) { }
  private readonly url: string = environment.url

  getProfile (territoryId: string, userId: string): Observable<any> {
    return this.httpClient.get(`${this.url}/profiles/${territoryId}/${userId}`)
  }
}
